export enum FlowsPages {
  APPOINTMENT_TYPE,
  INSURANCE,
  SCHEDULE_EXAM,
  PATIENT_DETAILS,
  ADD_NEW_PATIENT,
  CUSTOM_PAGE,
  CONTACT_DETAILS,
  TYP,
  CANCELED,
  CONFIRMED,
}
